import React from 'react';
import { RouterProvider } from 'react-router-dom';
import navigation from './navigation';
import './App.css';

import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import { Provider } from 'react-redux';
import store from './redux/store';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <RouterProvider router={navigation} />
      </Provider>
    </ThemeProvider>
  );
}

export default App;